// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Page-module--pageContainer--2RnS-","picture":"Page-module--picture--2mT40"};